import ProviderList from './ProviderList'
import PatientList from './PatientList'
import FilterList from './FilterList'
import QuestionnaireList from './QuestionnaireList'
import ReachoutList from './ReachoutList'
import UpcomingList from './UpcomingList'
import TagList from './TagList'
import PreviousList from './PreviousList'

export default {
	ProviderList,
	PatientList,
	FilterList,
	QuestionnaireList,
	ReachoutList,
	UpcomingList,
	TagList,
	PreviousList
}
